var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-card",style:({ padding: _vm.padding })},[_c('div',{staticClass:"header"}),_c('main',{staticClass:"main"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }